"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var CustomGallery_1 = require("./CustomGallery");
var DeletePics = /** @class */ (function (_super) {
    __extends(DeletePics, _super);
    function DeletePics(props) {
        var _this = _super.call(this, props) || this;
        _this.selectionChanged = function (photo, isSelected) {
            var result;
            if (isSelected) {
                result = _this.state.photosToDelete;
                result.push({
                    delete: isSelected,
                    path: photo.src
                });
            }
            else {
                result = _this.state.photosToDelete.filter(function (x) { return x.path !== photo.src; });
            }
            _this.setState({ photosToDelete: result });
        };
        _this.onRenderFooterContent = function () { return (React.createElement("div", { style: { minWidth: '200px', maxWidth: '600px' } },
            React.createElement(office_ui_fabric_react_1.Stack, { tokens: { childrenGap: 20 }, horizontal: true },
                React.createElement(office_ui_fabric_react_1.Stack.Item, { align: "start", grow: true },
                    React.createElement(office_ui_fabric_react_1.DefaultButton, { className: "ms-Cancel-Button", onClick: function () { return _this.confirmDialog(null); }, text: "Zur\u00FCck ohne speichern", primaryDisabled: false })),
                React.createElement(office_ui_fabric_react_1.Stack.Item, { align: "end", grow: true, styles: { root: { alignContent: "flex-end", flexGrow: 0 } } },
                    React.createElement(office_ui_fabric_react_1.PrimaryButton, { className: "ms-Default-Button2", onClick: function () { return _this.confirmDialog(_this.state.photosToDelete); }, text: "L\u00F6schen" }))))); };
        _this.updateData = function (headerText, files) {
            _this.setState({
                headerText: headerText, hideDialog: true,
                photos: files.map(function (x) { return ({
                    src: x,
                    height: 3,
                    width: 3
                }); }),
                photosToDelete: []
            });
        };
        _this.closeDialog = function () {
            _this.setState({ hideDialog: false });
        };
        _this.confirmDialog = function (photosToDelete) {
            _this.props.deleteEvent(photosToDelete);
        };
        _this.state = {
            hideDialog: false, headerText: "", photos: [], photosToDelete: []
        };
        return _this;
    }
    DeletePics.prototype.render = function () {
        var _this = this;
        return (this.state.hideDialog ?
            React.createElement(office_ui_fabric_react_1.Panel, { isOpen: this.state.hideDialog, onDismiss: function () { return _this.confirmDialog(null); }, type: office_ui_fabric_react_1.PanelType.custom, customWidth: "500px", onRenderFooterContent: this.onRenderFooterContent, isFooterAtBottom: true, headerText: "Bilder " + this.state.headerText + " löschen" },
                React.createElement("div", { style: { minWidth: "200px", maxWidth: "600px", height: "600px" } },
                    React.createElement("div", { style: { paddingLeft: "20px", paddingRight: "20px", paddingBottom: "20px", marginTop: "20px", height: "100%" } },
                        React.createElement(CustomGallery_1.CustomGallery, { photos: this.state.photos, selectedEvent: this.selectionChanged }))))
            : null);
    };
    return DeletePics;
}(React.Component));
exports.default = DeletePics;
//# sourceMappingURL=DeletePics.js.map